export enum QuizSteps {
  Main = 'main',
  Content = 'content',
  Settings = 'settings',
}
